import React from 'react';
import type {AstView, EnrichedAstNode} from 'rendition-core';

import {DisplayToggle} from 'Components/Editing/DisplayToggle';
import {ObjectFitToggle} from 'Components/Editing/ObjectFitToggle';
import {TextWrapToggle} from 'Components/Editing/TextWrapToggle';
import {AlignSelfToggle} from './FlexEdit/AlignSelfToggle';
import {EditorSuggestions} from './EditorSuggestions';
import {SizeEditor} from 'Components/Editing/SizeEditor';
import {MarginControl, PaddingControl} from 'Components/Editing/PaddingMarginControl';
import {FlexControls} from 'Components/Editing/FlexControls';

interface Props {
    selectedNodes: EnrichedAstNode[];
    view: AstView;
    setView: (view: AstView) => void;
    onSelectNodes: (nodes: string[]) => void;
}

export const segmentedControlClassNames = 'w-40';

export const Separator = () => <div className="h-px w-full bg-neutral-950" />;

export const EditControls: React.FC<Props> = ({selectedNodes, view, setView, onSelectNodes}) => {
    if (selectedNodes.length < 1) {
        return null;
    }
    return (
        <div className="flex w-full flex-col gap-3 p-2">
            <EditorSuggestions onSelectNodes={onSelectNodes} />
            <SizeEditor />
            <Separator />
            <DisplayToggle view={view} setView={setView} selectedNodes={selectedNodes} />
            <Separator />
            <TextWrapToggle view={view} setView={setView} selectedNodes={selectedNodes} />
            <ObjectFitToggle view={view} setView={setView} selectedNodes={selectedNodes} />
            <PaddingControl />
            <Separator />
            <MarginControl />
            <Separator />
            <AlignSelfToggle />
            <FlexControls view={view} setView={setView} selectedNodes={selectedNodes} />
        </div>
    );
};
